import React, { useImperativeHandle } from 'react';
import { View } from 'react-native';
export default ({ ref }) => {
    useImperativeHandle(ref, () => ({
        startConfetti: () => { },
        stopConfetti: () => { },
        removeConfetti: () => { },
    }));
    return <View />;
};
